<rt-dropdown
  [width]="dropdownWidth()"
  (click)="$event.preventDefault()"
  class="candidate-select-dropdown"
>
  @if (header) {
    <rt-dropdown-header>
      {{ header }}
    </rt-dropdown-header>
  }
  <div padding-small-x>
    <rt-form-field variant="rounded search">
      <rt-input
        #queryInput
        [placeholder]="'app.common.placeholders.search.candidates.other' | translate"
        [autoFocus]="true"
        [value]="this.state.query"
        [hasClearButton]="!!state.query && !state.loading"
        (reset)="reset()"
        (valueChange)="changeQuery($event)"
        variant="rounded"
      >
        <rt-icon prefix name="search" />
      </rt-input>
      @if (state.loading && state.query.length) {
        <rt-spinner variant="small" />
      }
    </rt-form-field>
  </div>
  @for (candidate of state.candidates; track trackByCandidate($index, candidate)) {
    <rt-dropdown-item (click)="selectCandidate.emit(candidate)">
      <div layout-horizontal>
        <div layout layout-align-items-center margin-right-small-x>
          <rt-avatar
            [type]="candidate.hasAvatar ? 'image' : 'initials'"
            [initials]="candidate.initials"
            [size]="'base'"
            [shape]="'oval'"
            [imageSrc]="candidate.photoThumbUrl"
            prefix
          />
        </div>
        <div layout-vertical layout-flex-1 layout-justify-center class="candidate-name-wrap">
          <div
            layout-horizontal
            layout-space-between
            layout-align-items-center
            class="candidate-name"
          >
            @if (candidate.highlight && candidate.highlight.name) {
              <div
                [innerHtml]="candidate.highlight.name[0]"
                class="text-content truncated-highlight"
              ></div>
            }
            @if (!(candidate.highlight && candidate.highlight.name)) {
              <div overflow-hidden class="text-content">
                <rt-truncate>
                  {{ candidate.name }}
                </rt-truncate>
              </div>
            }
          </div>
          @if (candidate.isHired) {
            <div class="already-hired-label">
              {{ 'app.assignments.candidates.already_hired' | translate }}
            </div>
          }
        </div>
      </div>
    </rt-dropdown-item>
  }
  @if (!state.loading && state.candidates.length === 0) {
    <rt-dropdown-item [hasHoverEffect]="false">
      @let emptyStateHeadingVal = emptyStateHeading();
      @let emptyStateSubheadingVal = emptyStateSubheading();
      <rt-empty-state
        variant="small"
        [icon]="'search'"
        [title]="
          !state.query && emptyStateHeadingVal
            ? emptyStateHeadingVal
            : ('app.layout.no_candidates_found' | translate)
        "
        [desc]="
          !state.query && emptyStateSubheadingVal
            ? emptyStateSubheadingVal
            : ('app.layout.no_candidates_found_desc' | translate)
        "
      >
        @if (state.query) {
          <rt-button (click)="reset()" variant="tertiary">
            {{ 'app.assignments.candidates.clear_search' | translate }}
          </rt-button>
        }
      </rt-empty-state>
    </rt-dropdown-item>
  }
</rt-dropdown>
